<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="canManagePeople ? items : null" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                        @change="searching"  
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Filter -->
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="branchRows"
                :row-key="record => record.branchid"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'branchid'">
                    <div class="productimgname">
                      <a href="javascript:void(0);">{{ record.branchname }}</a>
                    </div></template
                  >

                  <template v-else-if="column.key === 'action' && canManagePeople">
                    <a class="me-3" @click="editcustomer(record)" href="javascript:void(0);">
                      <img src="../../../../assets/img/icons/edit.svg" alt="img" />
                    </a>
                    <a
                      class="me-3 confirm-text"
                      href="javascript:void(0);"
                       @click="showAlert(record.branchid)"
                    >
                      <img src="../../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
  <custemerlistmodal></custemerlistmodal>
</template>
<script setup>
import { computed, toRefs } from 'vue';
import { useAuthenticator } from '@aws-amplify/ui-vue';

const { user } = toRefs(useAuthenticator());
const canManagePeople = computed(() => user.value?.attributes?.['custom:role'] === 'Admin');
</script>
<script>
import axios from "axios";
const columns = [
  {
    sorter: true,
  },
  {
    title: "Branch Name",
    dataIndex: "branchname",
    key: "branchid",
    sorter: {
      compare: (a, b) => {
        a = a.branchname.toLowerCase();
        b = b.branchname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Branch Head",
    dataIndex: "branchhead",
    sorter: {
      compare: (a, b) => {
        a = (a.branchhead || '').toLowerCase();
        b = (b.branchhead || '').toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "State",
    dataIndex: "statename",
    sorter: {
      compare: (a, b) => {
        a = (a.statename || '').toLowerCase();
        b = (b.statename || '').toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Phone",
    dataIndex: "phone",
    sorter: {
      compare: (a, b) => {
        a = a.phone;
        b = b.phone;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Email",
    dataIndex: "email",
    sorter: {
      compare: (a, b) => {
        a = a.email.toLowerCase();
        b = b.email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },

  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.common['api-key'] = process.env.VUE_APP_API_KEY;
const normalizeBranch = (branch) => ({
  branchid: branch.branchid || branch.BranchId || branch.id || '',
  branchname: branch.branchname || branch.BranchName || branch.name || '',
  branchhead: branch.branchhead || branch.BranchHead || '',
  statename: branch.statename || branch.StateName || '',
  phone: branch.phone || branch.Phone || '',
  email: branch.email || branch.Email || '',
  statecode: branch.statecode || branch.StateCode || '',
});

const getBranchListFromResponse = (responseData) => {
  if (typeof responseData === 'string') {
    try {
      return getBranchListFromResponse(JSON.parse(responseData));
    } catch (error) {
      console.log(error);
      return [];
    }
  }
  if (Array.isArray(responseData)) return responseData;
  if (responseData?.body) return getBranchListFromResponse(responseData.body);
  if (Array.isArray(responseData?.data)) return responseData.data;
  if (Array.isArray(responseData?.branches)) return responseData.branches;
  if (responseData && typeof responseData === 'object') {
    return Object.values(responseData).filter(item => item && typeof item === 'object');
  }
  return [];
};

export default {
  data() {
    return {
      filter: false,
      search: '',
      title: "Branch List",
      title1: "Manage your branches",
      items: [
        {
          text: "Add Branch",
          addname: "/addcustomer",
        },
      ],
      branches: [],
      columns,
    };
  },
  methods: {
    handleKeydown(event) {
      if (this.$route.path === '/customerlist' && event.ctrlKey && (event.key === 'm' || event.key === 'M')) {
        event.preventDefault(); 
        
        this.$router.push('/addcustomer');
      }
    },
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      // Use sweetalert2
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
          .delete('/v1/branches/'+id)
          .then(response => {
            Swal.fire("Deleted!", "Branch has been deleted.");
            var index = this.branches.findIndex(function(o){
              return o.branchid === id;
            })
            if (index !== -1) this.branches.splice(index, 1);
          })
          .catch(error => {
            console.log(error)
            Swal.fire(error.response.data.detail);
          });
          
        }
      });
    },
    editcustomer(branch) {
      this.$router.push({ path: '/editcustomer', query: { id: branch.branchid } });
    },
    async getItems() {
      axios
      .get('/v1/branches')
      .then(response => {
        this.branches = getBranchListFromResponse(response.data).map(normalizeBranch)
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  computed: {
    branchRows() {
      return (this.branches || []).filter(item => {
        const branchName = (item.branchname || '').toString().toLowerCase();
        const query = (this.search || '').toLowerCase();
        return !this.search || 
                branchName.includes(query);
      });
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
    this.getItems();
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  name: "customerlist",
};
</script>
